/* eslint-disable */
// Place at: src/components/onboarding/OnboardingButton.js
// Fully rounded (pill) button used only on the onboarding pages.
import {Pressable, StyleSheet, Text} from 'react-native';
import {colors, typography} from '../../config/theme';

const OnboardingButton = ({title, onPress, disabled = false, style}) => (
  <Pressable
    onPress={onPress}
    disabled={disabled}
    accessibilityRole="button"
    style={({pressed}) => [
      styles.button,
      pressed && styles.pressed,
      disabled && styles.disabled,
      style,
    ]}>
    <Text style={styles.text}>{title}</Text>
  </Pressable>
);

const styles = StyleSheet.create({
  button: {
    height: 56,
    borderRadius: 999, // fully rounded ends
    backgroundColor: colors.primary,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    overflow: 'hidden',
  },
  pressed: {opacity: 0.85},
  disabled: {opacity: 0.6},
  text: {
    ...typography.labelMd,
    fontSize: 16,
    color: colors.onPrimary,
    textAlign: 'center',
  },
});

export default OnboardingButton;